<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'MILLISECONDS'">
  <div app-theme-option-content>
    <app-number [value]="themeOptions.options().animation.duration" (sendValue)="receiveValue($event)" [color]="color" [min]="0" [max]="5000" [step]="500"></app-number>
  </div>
</app-theme-option>